"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var PlayersList_1 = require("./component/PlayersList");
var PlayerEditor_1 = require("./component/PlayerEditor");
var PlayerOperationsList_1 = require("./component/PlayerOperationsList");
var notificationHelper_1 = require("../../../../../shared/helpers/notificationHelper");
var PPlayersList = /** @class */ (function (_super) {
    __extends(PPlayersList, _super);
    function PPlayersList(props) {
        var _this = _super.call(this, props) || this;
        _this.PAGE_NUM_ONE = 1;
        return _this;
    }
    PPlayersList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AUB = this.props.ListPlayerBehaviorTypesAvail.Subscribe("*", function (id, data) {
            _this.setState({ usr_behaviors_avail: data.data });
        });
        this.SID_AB = this.props.brandsData.Subscribe("*", function (id, data) {
            _this.setState({ avail_brands: data.data });
        });
        this.SID_AT = this.props.listAppPlayerTagsAvail.Subscribe("*", function (id, data) {
            _this.setState({ avail_tags: data.short_data });
        });
        this.SID_AC = this.props.listAppCurrencyAvail.Subscribe("*", function (id, data) {
            _this.setState({ app_currency_avail: data.data });
        });
        this.SID_AL = this.props.listAppLanguageAvail.Subscribe("*", function (id, data) {
            _this.setState({ app_language_avail: data.data });
        });
        this.SID_TZ = this.props.ListTrustZonesAvail.Subscribe("*", function (id, data) {
            _this.setState({ trust_zones_avail: data.data });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                brands_list: data.brands_list,
                all_brands: data.all_brands,
                tags_list: data.tags_list,
                all_tags: data.all_tags,
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            player: null,
            page_num: this.PAGE_NUM_ONE,
            page_size: this.props.state.getTablePageSize(),
            brands_list: this.props.state.getBrandsList(),
            all_brands: this.props.state.getIsAllBrands(),
            avail_brands: [],
            tags_list: this.props.state.getTagsList(),
            all_tags: this.props.state.getIsAllTags(),
            avail_tags: [],
            app_currency_avail: [],
            app_language_avail: [],
            usr_behaviors_avail: [],
            trust_zones_avail: []
        }, function () {
            _this.props.brandsData.LoadData();
            _this.props.listAppPlayerTagsAvail.LoadData();
            _this.props.listAppCurrencyAvail.LoadData();
            _this.props.listAppLanguageAvail.LoadData();
            _this.props.ListPlayerBehaviorTypesAvail.LoadData();
            _this.props.ListTrustZonesAvail.LoadData();
        });
    };
    PPlayersList.prototype.componentWillUnmount = function () {
        this.props.ListPlayerBehaviorTypesAvail.UnSubscribe(this.SID_AUB);
        this.props.brandsData.UnSubscribe(this.SID_AB);
        this.props.listAppPlayerTagsAvail.UnSubscribe(this.SID_AT);
        this.props.listAppCurrencyAvail.UnSubscribe(this.SID_AC);
        this.props.listAppLanguageAvail.UnSubscribe(this.SID_AL);
        this.props.ListTrustZonesAvail.UnSubscribe(this.SID_TZ);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PPlayersList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", player: null });
    };
    PPlayersList.prototype.onSendBroadcastRawClick = function () {
        var _this = this;
        this.props.dlgSendBroadcastRawMsg
            .clearFields()
            .SetDialogTitle("Отправить текст сообщение")
            .SetMessageTitle("Заголовок сообщения")
            .SetMessageText("Текст сообщения")
            .SetBrands(this.state.avail_brands)
            .SetLanguages(this.state.app_language_avail)
            .SetOnYesClick(function (msgTitle, msgText, brandId, langId) {
            _this.props.dataMessages.DoSendBroadcastRawMsg({
                brand_id: brandId,
                app_language_id: langId,
                message_title: msgTitle,
                message_text: msgText
            }, function (sent_count) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E ",
                    React.createElement("b", null,
                        "[",
                        sent_count,
                        "]"),
                    " \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439"));
            });
            _this.props.dlgSendBroadcastRawMsg.Close();
        })
            .Show();
    };
    PPlayersList.prototype.onEditClick = function (playerObj) {
        this.setState({ edit_mode: "EDIT", player: playerObj });
    };
    PPlayersList.prototype.onGoToOperationsListClick = function (playerObj) {
        this.setState({ edit_mode: "LIST-OPERATIONS", player: playerObj });
    };
    PPlayersList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", player: null });
    };
    PPlayersList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PPlayersList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        var _this = this;
        this.setState({ page_num: this.PAGE_NUM_ONE }, function () {
            if (Action === "checkbox") {
                _this.props.state.setAllBrands(allBrands, true);
            }
            if (Action === "add") {
                _this.props.state.addBrand(BrandId, true);
            }
            if (Action === "remove") {
                _this.props.state.delBrand(BrandId, true);
            }
        });
    };
    PPlayersList.prototype.onTagFilterChanged = function (allTags, TagId, Action) {
        var _this = this;
        this.setState({ page_num: this.PAGE_NUM_ONE }, function () {
            if (Action === "checkbox") {
                _this.props.state.setAllTags(allTags, true);
            }
            if (Action === "add") {
                _this.props.state.addTag(TagId, true);
            }
            if (Action === "remove") {
                _this.props.state.delTag(TagId, true);
            }
        });
    };
    PPlayersList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(PlayerEditor_1.default, { data: this.props.data, state: this.props.state, player: null, onGoBack: this.onGoBackClick.bind(this), brandsAvail: this.state.avail_brands, listAffilatesAvail: this.props.listAffilatesAvail, appCurrencyAvail: this.state.app_currency_avail, appLanguageAvail: this.state.app_language_avail, listAffilatesPartnersAvail: this.props.listAffilatesPartnersAvail, listAffilatesPartnersOffersAvail: this.props.listAffilatesPartnersOffersAvail, listAffilatesPartnersTrackersAvail: this.props.listAffilatesPartnersTrackersAvail, ListGameProviderZones: this.props.ListGameProviderZones, usr_behaviors_avail: this.state.usr_behaviors_avail, trust_zones_avail: this.state.trust_zones_avail }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(PlayerEditor_1.default, { data: this.props.data, state: this.props.state, player: this.state.player, onGoBack: this.onGoBackClick.bind(this), brandsAvail: this.state.avail_brands, listAffilatesAvail: this.props.listAffilatesAvail, appCurrencyAvail: this.state.app_currency_avail, appLanguageAvail: this.state.app_language_avail, listAffilatesPartnersAvail: this.props.listAffilatesPartnersAvail, listAffilatesPartnersOffersAvail: this.props.listAffilatesPartnersOffersAvail, listAffilatesPartnersTrackersAvail: this.props.listAffilatesPartnersTrackersAvail, ListGameProviderZones: this.props.ListGameProviderZones, usr_behaviors_avail: this.state.usr_behaviors_avail, trust_zones_avail: this.state.trust_zones_avail }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(PlayersList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onSendBroadcastRawClick: this.onSendBroadcastRawClick.bind(this), onEditClick: this.onEditClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, dlgPwd: this.props.dlgPwd, dlgView: this.props.dlgView, dlgExport: this.props.dlgPlayerExport, 
                //
                brandsList: this.state.brands_list, allBrands: this.state.all_brands, availBrands: this.state.avail_brands, onBrandFilterChanged: this.onBrandFilterChanged.bind(this), 
                //
                tagsList: this.state.tags_list, allTags: this.state.all_tags, availTags: this.state.avail_tags, onTagFilterChanged: this.onTagFilterChanged.bind(this), 
                //
                onGoToOperationsListClick: this.onGoToOperationsListClick.bind(this), DlgNumericEditor: this.props.DlgNumericEditor }));
        }
        if (this.state.edit_mode === "LIST-OPERATIONS") {
            return (React.createElement(PlayerOperationsList_1.default, { data: this.props.data, state: this.props.state, dataDeposit: this.props.financeDepositData, dataWithdraw: this.props.financeWithdrawData, dlgFinance: this.props.dlgFinance, onGoBackClick: this.onGoBackClick.bind(this), player: this.state.player, dataMessages: this.props.dataMessages, dataBonuses: this.props.dataBonuses, dataCfgBonusWagerNoDep: this.props.dataCfgBonusWagerNoDep, dataCfgBonusWagerOnDep: this.props.dataCfgBonusWagerOnDep, dataCfgBonusWagerCashb: this.props.dataCfgBonusWagerCashBack, dataPromocodes: this.props.dataPromocodes, dlgMessage: this.props.dlgMessage, dataAvailTags: this.props.dataAvailTags, dataPlayerTags: this.props.dataPlayerTags, dlgSelectTag: this.props.dlgSelectTag, dataAuthLogs: this.props.dataAuthLogs, dataGameLogs: this.props.dataGameLogs, dataFavoriteGames: this.props.dataFavoriteGames, gwsGamesData: this.props.listGwsGamesData, gwsGameprovidersData: this.props.listGwsGameprovidersData, brandsData: this.state.avail_brands, listBonusTemplatesAvail: this.props.listBonusTemplatesAvail, listBonusDebitTypes: this.props.listBonusDebitTypes, listBonusCancelTypes: this.props.listBonusCancelTypes, dlgYesNo: this.props.dlgYesNo, dataJpWins: this.props.dataJpWins, dataJpAvail: this.props.dataJpAvail, listBonusPermissionTypes: this.props.listBonusPermissionTypes, listBonusWithdrawTypes: this.props.listBonusWithdrawTypes, listGameSet: this.props.listGameSet, listGameSetGames: this.props.listGameSetGames, ListBonusLevelSrcTypesAvail: this.props.ListBonusLevelSrcTypesAvail, ListGameProviderZones: this.props.ListGameProviderZones, ListPlayerTournaments: this.props.ListPlayerTournaments, dataMultiaccounts: this.props.dataMultiAccounts, dataSmsLogs: this.props.ListPlayerSmsLogs, dataBonusEventsLogs: this.props.PlayerBonusEventsLogsList, PlayersWhiteIpList: this.props.PlayersWhiteIpList, dlgWhiteIpEditor: this.props.dlgWhiteIpEditor }));
        }
        throw "No available render for active edit mode -> [" + this.state.edit_mode + "]";
    };
    PPlayersList.prototype.render = function () {
        return this.getRenderObject();
    };
    PPlayersList.getPageDescription = function (state) {
        return {
            icon: "user",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_main_clients_list + "-id",
            itemTitle: "Игроки",
            route: routes_1.routes.page_main_clients_list,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PPlayersList;
}(React.Component));
exports.default = PPlayersList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ui/PPlayersList.tsx
// module id = 1917
// module chunks = 0